import ApiClient from '@afosto/api/ApiClient';

class Rbac {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a new role
   *
   * @param {Object} body - Role object
   * @param {Object} options - The additional request options
   * @description Make a new RBAC role available
   * @returns {Promise}
   */
  createRole(body, options = {}) {
    return this.apiClient.request({
      url: `/iam/roles/tenant`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Delete an existing role
   *
   * @param {Number} id
   * @param {Object} options - The additional request options
   * @description Delete a RBAC role
   * @returns {Promise}
   */
  deleteRole(id, options = {}) {
    return this.apiClient.request({
      url: `/iam/roles/tenant/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * View an rbac role
   *
   * @param {Number} id
   * @param {Object} options - The additional request options
   * @description Returns the rbac role
   * @returns {Promise}
   */
  getRole(id, options = {}) {
    return this.apiClient.request({
      url: `/iam/roles/tenant/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a single rbac system defined role
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Returns a single rbac role
   * @returns {Promise}
   */
  getSystemRole(id, options = {}) {
    return this.apiClient.request({
      url: `/iam/roles/system/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of rbac roles
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of available rbac roles
   * @returns {Promise}
   */
  listRoles(options = {}) {
    return this.apiClient.request({
      url: `/iam/roles/tenant`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of rbac system defined rbac roles
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.clientId]
   * @param {Object} options - The additional request options
   * @description Returns a list of available rbac roles
   * @returns {Promise}
   */
  listSystemRoles(query = {}, options = {}) {
    const params = {
      client_id: query.clientId,
    };

    return this.apiClient.request({
      url: `/iam/roles/system`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Update an existing role
   *
   * @param {Number} id
   * @param {Object} body - Role object
   * @param {Object} options - The additional request options
   * @description Update a RBAC role
   * @returns {Promise}
   */
  updateRole(id, body, options = {}) {
    return this.apiClient.request({
      url: `/iam/roles/tenant/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const rbac = new Rbac();

export default Rbac;
